import React from 'react';
import { useApolloClient } from '@apollo/client';
// Api
import { GET_STORES } from 'api/store/queries';
// Types
import {
  GetStores,
  GetStoresVariables,
  GetStores_adminStores_entities,
} from 'api/store/types/GetStores';
import { LoadMore, OptionsItem } from './SectionItem';
import {
  SortDirection,
  AdminStoresOrderBy,
  StoreStatus,
  UserRole,
} from 'api/graphql-global-types';
import { HomePageSectionItemProps } from 'pages/HomePageManagement';
import { GetHomePageData_getHomePageData_stores } from 'api/homePageSetup/types/GetHomePageData';
// Components
import SectionItem from './SectionItem';
// Helpers
import { getStoreName } from 'helpers/utils';

export const getStoreLabel = (
  store: GetHomePageData_getHomePageData_stores | GetStores_adminStores_entities
): string => {
  return getStoreName(store);
};

const PER_PAGE = 10;

const SetupStoreSectionItem: React.FC<HomePageSectionItemProps> = ({
  selectedItems,
  onItemChange,
  item,
  itemIndex,
}) => {
  const client = useApolloClient();

  const loadMore: LoadMore = async (offset, search) => {
    const options: OptionsItem[] = [];

    const { data } = await client.query<GetStores, GetStoresVariables>({
      query: GET_STORES,
      variables: {
        storeRoles: [UserRole.Athlete],
        input: {
          ...(search
            ? {
                storeName: search,
              }
            : {}),
          status: [StoreStatus.Active],
          orderBy: AdminStoresOrderBy.storeName,
          direction: SortDirection.ASC,
          limit: PER_PAGE,
          offset,
        },
      },
      fetchPolicy: 'network-only',
    });

    const total = data?.adminStores?.total || 0;

    data?.adminStores?.entities?.forEach((item) => {
      options.push({
        value: item.id,
        label: getStoreLabel(item),
      });
    });

    return { total, options };
  };

  return (
    <SectionItem
      selectPlaceholder="Pick the Store"
      selectedItems={selectedItems}
      onItemsChange={onItemChange}
      item={item}
      itemIndex={itemIndex}
      paginationSize={PER_PAGE}
      loadMore={loadMore}
    />
  );
};

export default SetupStoreSectionItem;
